import React from 'react';
import IcAddButton from './AddButton.svg';
import styles from './AddButton.module.scss';
import {useADSContext} from "../../../../../../context/ADSProvider";

const AddButton = () => {
  const { handleSelectProduct} = useADSContext()

  const handleAddNewImage = () => {
    handleSelectProduct({})
  }

  return (
    <img className={styles.wrapper} src={IcAddButton} alt="add-button" onClick={handleAddNewImage} />
  );
};

export default AddButton;
